// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setMasterData } from "_core/slices/datas/MasterSlice";
import { setApiTimestamp, setTransactionData } from "_core/slices/datas/TransactionSlice";


const AssetsDownloadApi = () => {
    // API固有の設定、URLとリクエスト
    const url = "/assets/download";

    // API実行
    const ExecAssetsDownloadApi = async ({ hash }) => {
        // 必要なリクエストを定義
        const requestParams = {
            hash: hash,
            is_editor: true
        };
    
        let response = null;
        let error = null;
    
        // console.log(url + "API開始");
        try {
            response = await ApiRequest({  url:url, requestParams:requestParams });
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            // バイナリレスポンスのためデータ更新なし
        }
        return { response, error };
    };

    return ExecAssetsDownloadApi;
};

export default AssetsDownloadApi;